import { Alert, AlertTitle, Skeleton } from "@mui/material";
import { ApiQueries, DaymapIcon, DaymapIconType, NotificationType, prettyDate, useNotifications, useSettings, useStudent, TableComponent } from "daymap-react";
import { useParams, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { PageContainer, PageDescriptor } from "../../../components/layout";

function Points() {
    const { studentId } = useParams();
    const [params] = useSearchParams();
    const { setReadFromProps } = useNotifications();
    const { settings} = useSettings();
    const student = useStudent(Number(studentId));
    const { isPending: isPendingPoints, error: errorPoints, data: pointsData } = new ApiQueries.points.PointsForStudent({ studentId: Number(studentId) }).ToQuery();
    const { isPending: isPendingPointLog, error: errorPointLog, data: pointLogData } = new ApiQueries.points.PointLogForStudent({ studentId: Number(studentId) }).ToQuery();

    useEffect(() => {
        // we have come to this page via a points notification so set that one to read 
        if (params.get("rowId")) {
            setReadFromProps({
                ObjectID: Number(params.get("rowId")),
                Type: NotificationType.PointsAdded,
                Properties: { StudentID: studentId!.toString() }
            })
        }
    }, []);

    let updatedLog = pointLogData 
    ? pointLogData.map(r => {
        const teacher = `${r.TeacherFirstName} ${r.TeacherSurname}`;
        const fullCategory = r.Category + (r.SubCategory ? ` > ${r.SubCategory}` : '');
        const date = prettyDate (r.TransactionDateTime, {showTime: false});
        return { ...r, teacher, fullCategory, date };
    })
    : [];

    const columns = ["Date", "Teacher", "Category", "Points", "Comment"];
    
    const rows = updatedLog.map((log) => ({
        date: log.date,
        teacher: log.teacher,
        category: log.fullCategory,
        points: log.Points,
        comment: log.Comment,
    }));

    return <PageContainer>
        <PageDescriptor icon={<DaymapIcon iconType={DaymapIconType.Points} />} title={settings ? settings.pointsName : ""} >
            View a log of points assigned to {student?.Displayname} this year
        </PageDescriptor>
        {errorPointLog && <Alert color="error">
            {errorPointLog.title && <AlertTitle>{errorPointLog.title}</AlertTitle>}
            {errorPointLog.detail}
        </Alert>}
        {errorPoints && <Alert color="error">
            {errorPoints.title && <AlertTitle>{errorPoints.title}</AlertTitle>}
            {errorPoints.detail}
        </Alert>}
        {isPendingPoints ? (<Skeleton variant="text" width = '70px' sx={{fontSize: '1rem'}}/>):(<p style={{ paddingLeft: 'calc(2 * var(--mui-spacing))' }}>Current points this year: {pointsData}</p>)}
        <TableComponent 
            columns={columns} 
            rows={rows} 
            isPending={isPendingPointLog}
            rowKey={(_, index) => updatedLog[index]?.RowID ?? index}
            selectedRowKey={params.get("rowId") ?? undefined}
        />
    </PageContainer> 
}

export default Points;